
jQuery(document).ready(function(){

  $('.size-chart').click(function(){
    $('#size-chart-popup').addClass('active');
  });

  $('#size-chart-popup .close').click(function(){
       $('#size-chart-popup').removeClass('active');
  });
  
  $('.home-products').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
   ]
  });
		

  //home page product swapper
  jQuery('.home-swatch').hover(function(){
  	let cColor = jQuery(this).data('color');
    let cImage = jQuery(this).data('product-image');
    let cTitle = jQuery(this).data('title');
    let cLink = jQuery(this).data('link');
    
    jQuery(this).closest('.swatch-container').find('.home-swatch').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).closest('.home-product-box').css('background-image', 'url(' + cImage + ')');
    jQuery(this).closest('.home-product-box').find('#product-color').text(cColor);
    jQuery(this).closest('.home-product-box').attr('href', cLink);  
  })
  	
  
})